export const KYC_CONTRACT_ADDRESS = "0x0D1927E2b54b0D91A57f74C05dF779802F7110cE";
export const FAKT_CONTRACT_ADDRESS = "0xA605aa2aA3f583D1e2570461D0c860f855B69804";
export const STAKING_CONTRACT_ADDRESS = "0xAE25c92a745cf3f9a91643725887C57f9419F8da";
